import * as React from "react";
import { Sidebar, Topbar, AvatarEditor, ProfileEditor, PasswordChanger, AppFooter, useCurrentUser } from "./common";

// 내 계정(데스크톱) — 본인 이름·연락처·비밀번호를 self-service로 수정한다.
// 백엔드는 PATCH /api/v1/users/me, /api/v1/users/me/password(require_login!)를
// 이미 제공하고, 카드 UI(ProfileEditor/PasswordChanger)도 모바일 마이페이지와
// 공유한다. 이 화면은 데스크톱 사이드바를 쓰는 운영 역할(권역/플랫폼/유관기관)에게
// 그 진입점을 열어줄 뿐이라 신규 로직이 없다.
// 탈퇴(AccountWithdraw)는 의도적으로 제외 — 관리자 역할은 본인 탈퇴 불가
// (users#withdraw가 CONSUMER_ROLES만 허용).
function AccountSettings() {
  const { user, loaded } = useCurrentUser();
  if (!loaded) return null;

  // 데스크톱 사이드바 매핑(members/dashboard 화면과 동일 관용): 시스템 관리자는
  // platform, 유관기관은 agency, 그 외(권역 관리자)는 region 내비를 쓴다.
  const navRole = user?.role === "system_admin" ? "platform"
                : user?.role === "agency"       ? "agency"
                : "region";

  return (
    <div className="app" style={{height:'100vh'}}>
      <div className="shell">
        <Sidebar role={navRole} active="account"/>
        <div style={{display:'flex', flexDirection:'column', overflow:'hidden'}}>
          <Topbar title="내 계정" sub="이름·연락처·비밀번호를 관리합니다"/>
          <div className="main">
            <div style={{maxWidth:560}}>
              <div className="h1" style={{marginBottom:4}}>내 계정</div>
              <div className="muted" style={{marginBottom:18, fontSize:13}}>
                본인 이름·연락처와 비밀번호를 직접 수정할 수 있습니다. 이메일·역할·권역은
                보안상 셀프 변경 대상이 아니며, 변경이 필요하면 시스템 관리자에게 문의해주세요.
              </div>
              <AvatarEditor user={user}/>
              <ProfileEditor user={user}/>
              <PasswordChanger/>
            </div>
            <AppFooter/>
          </div>
        </div>
      </div>
    </div>
  );
}

export { AccountSettings };
